import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import AnimatedCol from "../../../../components/AnimatedCol";
import Millimetre from "../../../../components/Math/Units/Metric/Millimetre";
import { RowBody } from "../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../components/ToolTip";
import { berechneAchsabstand } from "../../../../services/berechnePileHead";
import { selectWerkstoffUebergangsrohr } from "../../../../store/slices/pileHeadConstructionSlice";
import AbstandKopfplatteÜbergangsrohr from "./Abstand_UK_Kopfplatte_OK_Übergangsrohr";
import KopfplatteDicke from "./KopfplatteDicke";
import KopfplatteKantenlaenge from "./KopfplatteKantenlaenge";

function LageKopfplatteUndUbergangsrohr({
  kopfkonstruktion,
  minimalerRandabstand = 0,
  durchmesserDesRohres = 0,
}) {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();
  const druckMode = useSelector(selectWerkstoffUebergangsrohr, Object.is);

  const mindest_randabstand_formula = `\\displaystyle R \\ge 1,5 \\cdot D + 0,5 \\cdot U`;
  const mindest_pfahlabstand_formula = `\\displaystyle X \\ge 3 \\cdot D + U`;

  const [achsabstand, setAchsabstand] = useState(0);

  useEffect(() => {
    let achsabstand = berechneAchsabstand(durchmesserDesRohres, kopfkonstruktion?.kantenlaenge);

    setAchsabstand(achsabstand);
  }, [durchmesserDesRohres, kopfkonstruktion]);

  return (
    <div className="row">
      <div className="col-md-12">
        <h3>{t("aeussre.DimensionsPositionHeadPlate")}</h3>
      </div>

      <AnimatedCol>
        <KopfplatteKantenlaenge kantenlaenge={kopfkonstruktion?.kantenlaenge} />
      </AnimatedCol>

      <AnimatedCol>
        <KopfplatteDicke dicke={kopfkonstruktion?.dicke} />
      </AnimatedCol>

      <AnimatedCol>
        <AbstandKopfplatteÜbergangsrohr
          abstandUebergangsrohr={kopfkonstruktion?.abstand_uebergangsrohr}
        />
      </AnimatedCol>

      <AnimatedCol expand={druckMode == 0}>
        <RowBody
          titleValue={<p>{t("aeussre.minEdgeDistance")}</p>}
          indicesValue={
            <span>
              R<sub>min</sub>
            </span>
          }
          inputValue={<span className="input">{minimalerRandabstand?.toFixed(0)}</span>}
          unitValue={<Millimetre />}
          formulaValue={
            <ToolTip
              id={"mindest_randabstand_formula"}
              type={IconType.FORMULA}
              formula={mindest_randabstand_formula}
            />
          }
        />
      </AnimatedCol>

      <AnimatedCol expand={druckMode == 0}>
        <RowBody
          titleValue={<p>{t("aeussre.minWheelbase")}</p>}
          indicesValue={
            <span>
              X<sub>min</sub>
            </span>
          }
          inputValue={<span className="input">{achsabstand.toFixed(0)}</span>}
          unitValue={<Millimetre />}
          formulaValue={
            <ToolTip
              id={"mindest_pfahlabstand_formula"}
              type={IconType.FORMULA}
              formula={mindest_pfahlabstand_formula}
            />
          }
        />
      </AnimatedCol>
    </div>
  );
}

export default LageKopfplatteUndUbergangsrohr;
